import React from 'react';
import cn from 'clsx';

import Tab from './tab/tab';

import styles from './tabs.scss';

interface TabsProps {
  className?: string;
  isSecondary?: boolean;
}

function Tabs(props: React.PropsWithChildren<TabsProps>) {
  const { children, className = '', isSecondary } = props;

  const childrenArray = React.useMemo(
    () => React.Children.toArray(children),
    [children]
  );

  const childrenWithInjectedProps = React.useMemo(() => {
    if (!childrenArray?.length) {
      return null;
    }

    function injectTabProps(node: React.ReactNode): React.ReactNode {
      return React.Children.map(node, child => {
        if (!React.isValidElement(child)) {
          return child;
        }

        if (child.type === Tab) {
          return React.cloneElement(child as React.ReactElement, {
            ...child.props,
            isSecondary
          });
        }

        if (!child.props?.children) {
          return child;
        }

        return React.cloneElement(child as React.ReactElement, {
          ...child.props,
          children: injectTabProps(child.props.children)
        });
      });
    }

    return injectTabProps(childrenArray);
  }, [childrenArray, isSecondary]);

  if (!childrenArray?.length) return null;

  return (
    <div
      className={cn(styles['container'], `tabs ${className}`)}
      role="tablist"
    >
      {childrenWithInjectedProps}
    </div>
  );
}

export { Tab };
export default Tabs;
